<template>
  <div class="job_category">
    <div class="gsjj">
      <p class="p1">职位类别</p>
      <div class="fg"></div>
    </div>
    <div class="cont">
      <div
        class="item"
        v-for="(item, index) in solveList"
        :key="index"
        :class="index == selectIndex ? 'select' : ''"
      >
        <div class="img_wrap" @click="search(item.title, index)">
          <img :src="item.url" alt="" />
          <div class="text">
            <span>{{ item.title }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModuleTitleSecond from "@/components/ModuleTitle/second";
export default {
  components: {
    ModuleTitleSecond,
  },
  data() {
    return {
      selectIndex: -1,
      solveList: [
        {
          title: "产品/项目类",
          url: require("../../assets/images/job/manage1.png"),
          desc: "",
        },
        {
          title: "技术类",
          url: require("../../assets/images/job/technician1.png"),
          desc: "",
        },
        {
          title: "测试类",
          url: require("../../assets/images/job/tester1.png"),
          desc: "",
        },
        {
          title: "设计类",
          url: require("../../assets/images/job/designer1.png"),
          desc: "",
        },
      ],
    };
  },
  props: ["onsearch"],
  methods: {
    search: function (title, index) {
      let me = this;
      this.selectIndex = index;
      me.onsearch && me.onsearch("", title);
    },
  },
  mounted() {
    this.search('产品/项目类', 0)
  },
};
</script>

<style lang="scss" scoped>
.gsjj {
  width: 208px;
  height: 99px;
  // background-color: #073875;
  margin: 40px auto;
}
.fg {
  width: 165px;
  height: 5px;
  background: #0a41ff;
  border-radius: 0px 0px 0px 0px;
  margin: 47px 21px 0px 22px;
}
.p1 {
  width: 208px;
  height: 52px;
  font-size: 52px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #333333;
  background-color: rgba(255, 255, 255, 0);

  line-height: 93px;
  // -webkit-background-clip: text;
  // -webkit-text-fill-color: transparent;
}
.job_category {
  width: 100%;
  padding: 10px 0 50px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.job_category .cont {
  width: 83%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.job_category .item {
  width: 45%;
  height: 408px;
  background-color: #ffffff;
  border-radius: 5px;
  padding: 10px;
  border: 1px solid #d5e0f1;
  margin: 0 0 20px;
}

.job_category .select {
  box-shadow: 0 0 10px -4px rgb(0 0 0 / 50%);
}

.job_category .select .text span {
  padding-bottom: 10px;
  border-bottom: 10px solid #0a41ff;
}

.img_wrap {
  text-align: center;
}

.img_wrap img {
  width: 100px;
  height: 100px;
  margin: 106px 0 75px;
}

.job_category .text {
  line-height: 50px;
  font-size: 20px;
}

.job_category .text span {
  padding: 0 0 5px;
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 36px;
  color: #333333;
}
</style>